type UploadStatus = "done" | "error" | "uploading";
export type UploadType =
    | "placeholder"
    | "tus"
    | "uploadedTus";

export interface InitialPlaceholderFile {
    id: string;
    name: string;
    size: number;
    type: "placeholder";
}

export interface InitialTusFile {
    id: string;
    name: string;
    size: number;
    type: "tus";
    url: string;
}

export type InitialFile =
    | InitialPlaceholderFile
    | InitialTusFile;

interface UploadParameters {
    name: string;
    status: UploadStatus;
    type: UploadType;
    uploadIndex: number;
}

abstract class BaseUpload {
    name: string;
    status: UploadStatus;
    type: UploadType;
    uploadIndex: number;

    constructor({ name, status, type, uploadIndex }: UploadParameters) {
        this.name = name;
        this.status = status;
        this.type = type;
        this.uploadIndex = uploadIndex;
    }

    public async abort(): Promise<void> {
        //
    }
    public async delete(): Promise<void> {
        //
    }
    public abstract getSize(): number | undefined;

    public abstract getInitialFile(): InitialFile;

    public getUrl(): string | null {
        return null
    }
}

export default BaseUpload;
